import utils from "@/stuff/Utils";

export class PasswordChangeRequest {
    userID: number = 0;
    existingPassword: string = "";
    newPassword: string = "";
    repeatPassword: string = "";
}